import { ThemeProvider } from "@mui/material/styles";
import React, { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { RouterProvider } from "react-router-dom";
import "./App.scss";
import { app_router } from "./utils/app_router";
import { useClient } from "./utils/client_info";
import themeConfig from "./utils/theme_config";

function App() {
  const { setClientName } = useClient();
  const [theme] = React.useState(themeConfig("#000000"));
  const auth = useAuth();

  useEffect(() => {
    const fetchClientName = async () => {
      const client = auth?.user?.profile["cognito:groups"][0];
      setClientName(client);
    };
    fetchClientName();
  }, [auth?.user?.profile, setClientName]);

  // useEffect(() => {
  //   if (clientName) {
  //     const clientConfig = {
  //       primary: {
  //         main: "#ffffff",
  //       },
  //       barGraph: [
  //         "#1A303F",
  //         "#1A303F",
  //         "#1A303F",
  //         "#1A303F",
  //         "#1A303F",
  //         "#1A303F",
  //       ],
  //     };

  //     const { primary, barGraph } = clientConfig;
  //     setTheme(themeConfig(primary.main)); // Pass the 'main' property
  //     // document.documentElement.style.setProperty(
  //     //   "--primary-color",
  //     //   primary.main
  //     // );

  //     barGraph.forEach((color, index) => {
  //       document.documentElement.style.setProperty(
  //         `--bar-color-${index + 1}`,
  //         color
  //       );
  //     });
  //   }
  // }, [clientName]);

  return (
    <ThemeProvider theme={theme}>
      <RouterProvider router={app_router} />
    </ThemeProvider>
  );
}

export default App;
